/**
 * ExportSection Component
 * 
 * Displays save and restart buttons for data export workflow.
 */

import React from 'react';
import SaveButton from '@/shared/components/buttons/SaveButton';
import RestartButton from '@/shared/components/buttons/RestartButton';

export interface ExportSectionProps {
  /** Callback to trigger save */
  onSave: () => void;
  /** Callback to restart workflow */
  onRestart: () => void;
  /** Whether there is data to save */
  hasData: boolean;
  /** Whether an operation is in progress */
  isLoading: boolean;
}

export const ExportSection: React.FC<ExportSectionProps> = ({
  onSave,
  onRestart,
  hasData,
  isLoading,
}) => {
  if (!hasData) {
    return null;
  }

  return (
    <div className="mt-8 flex justify-start items-center gap-4 flex-wrap">
      <SaveButton
        onSave={onSave}
        iconSize={28}
        disabled={isLoading}
        aria-label="Save processed data"
      />
      <RestartButton
        onRestart={onRestart}
        iconSize={28}
        disabled={isLoading}
        aria-label="Reset all data"
      />
    </div>
  );
};

export default ExportSection;
